export default __webpack_public_path__ + "static/media/thop-aparelho-fixo.977465fe.png";